export default "__VITE_ASSET__C1Ui4bTW__"